import { Type } from "js-yaml";
class ParsedGoal {
  key;
  constructor(key) {
    this.key = key;
  }
}
const GoalTag = new Type("!goal", {
  kind: "scalar",
  resolve: (goal) => goal !== null && typeof goal === "string",
  construct: (goal) => new ParsedGoal(goal),
  instanceOf: ParsedGoal,
  represent: (goal) => goal.key
});
export {
  GoalTag,
  ParsedGoal
};
